import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { TimelineItem } from 'views/Tasks/Timeline/types';
import { normalizeTimelineId } from 'views/Tasks/Timeline/helpers';

/**
 * Cache key for a timelines fetch. Omit `includeAssignees` for the prefix that matches
 * (and so invalidates) every variant.
 */
export const getTimelinesQueryKey = (orgId: string, dealId: number, includeAssignees?: boolean) => (
    includeAssignees === undefined ? ['timelines', orgId, dealId] : ['timelines', orgId, dealId, includeAssignees]
);

export const getTimelines = async (
    { orgId, dealId, includeAssignees = false }: { orgId: string; dealId: number; includeAssignees?: boolean },
): Promise<TimelineItem[]> => {
    const url = includeAssignees
        ? `${API_ENDPOINTS.TIMELINES(orgId, dealId)}?include_assignees=true`
        : API_ENDPOINTS.TIMELINES(orgId, dealId);
    const response = await axiosInstance.get<TimelineItem[]>(url);
    return response.data.map(normalizeTimelineId);
};

export const useGetTimelines = ({ orgId, dealId, includeAssignees = false }: { orgId: string; dealId: number; includeAssignees?: boolean }) => useQuery({
    queryKey: getTimelinesQueryKey(orgId, dealId, includeAssignees),
    queryFn: () => getTimelines({ orgId, dealId, includeAssignees }),
});
